<template>
	<div class="row background-graphic">
	</div>

	<div class="row main-content mb-5">
		<div class="col-lg-12">

			<div class="row row-header no-select">
				<div class="col-12 col-lg-auto col-bundle-name">
					<h1>{{oBundle.name}}<span class="span-edit" v-if="isAdmin"> - <a :href="urlEdit" rel="nofollow">Edit</a></span></h1>
				</div>
				<div class="col-12 col-lg col-bundle-tags" v-show="false">
					<a class="bundle-tag" :href="urlSocialMediaType">{{anchorSocialMediaType}}</a>
					<a class="bundle-tag" :href="urlCategory">{{anchorCategory}}</a>
				</div>
			</div>

			<div class="row row-main-content mt-3">
				<div class="col-lg left-section">
					<div class="row row-selected-bundle-image">
						<div class="col-md-12 bundle-image-container mt-0" @mouseover="setMouseHover(true)" @mouseleave="setMouseHover(false)">
							<img
								:src="selectedImageUrl"
								:alt="selectedImageAlt"
								:srcset="selectedImageSrcSet"
								:sizes="selectedImageSizes"
								:width="selectedImageWidth"
								:height="selectedImageHeight"
								class="bundle-image-full"
								loading="eager" fetchpriority="high"
								@load="onImageLoaded">
							<div class="carousel-indicator-container" v-show="showNavArrows">
								<ul class="carousel-indicator">
									<li v-for="(image, i) in oBundleImages" class="img-indicator" :class="clsImageIndicator(i)" @click="selectImage(i)"></li>
								</ul>
							</div>
							<button type="button" class="nav-arrow arrow-prev" aria-label="Previous" @click="selectPrevImage()" v-show="showNavArrows"></button>
							<button type="button" class="nav-arrow arrow-next" aria-label="Next" @click="selectNextImage()" v-show="showNavArrows"></button>
							<img src="/img/loaders/black-bg.svg" class="img-overlay black-bg" loading="eager" v-show="imageLoading" />
							<img src="/img/loaders/image-load-overlay.svg" class="img-overlay img-loader" loading="eager" v-show="imageLoading" />
						</div>
					</div>
					<div class="row row-image-bundles">
						<div v-for="(image, i) in oBundleImages" :key="image.id" class="col-lg-2 bundle-image-container" @click="selectImage(i)">
							<img :src="getImagePreviewUrl(image)" :alt="getImagePreviewAlt(i)" :width="getImagePreviewWidth(image)" :height="getImagePreviewHeight(image)" class="bundle-image-preview grow" loading="lazy" decoding="async" fetchpriority="low" :class="thumbnailClass(i)" @load="onImageLoaded" />
						</div>
					</div>
					<div class="row row-description no-select mt-3" v-show="showDescription">
						<div class="col-md-12">
							<div class="description-box shadowbase">
								<div v-html="oBundle.descriptionHtml"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-auto right-section">
					<div class="cta-box cta-box-specs no-select">
						<div>
							<div class="cta-button-container" v-show="showButtonDownload">
								<input type="button" class="btn btn-primary shadow-none cta-button-styling" :value="getTextClaimOrBuyButton" @click="guestClicksDownload" />
							</div>
							<div class="cta-button-container" v-show="showButtonClaim">
								<input type="button" class="btn btn-primary shadow-none cta-button-styling" :value="getTextClaimOrBuyButton" @click="spendAccountCreditOnBundle" />
							</div>
							<div class="cta-button-container" v-show="showButtonBuy">
								<input type="button" class="btn btn-primary shadow-none cta-button-styling" :value="getTextClaimOrBuyButton" data-bs-toggle="modal" data-bs-target="#modal-container-payment-form" @click="preparePaymentForm" />
							</div>
							<div class="cta-button-container" v-show="showButtonProcessing">
								<input type="button" class="btn btn-primary shadow-none cta-button-styling" value="Processing..." disabled />
							</div>
						</div>
						<div class="" v-if="showMessageLoginRegister">
							<div class="cta-login-or-register text-center">
								<p class="mb-0"><b>Login</b> or <b>register</b> to get started.</p>
								<button-facebook-login :app-id="fbAppId" :version="fbVersion" :width="loginButtonWidth" class="mt-2" v-show="showButtonFacebook"></button-facebook-login>
								<button-google-login :clientId="gClientId" :width="loginButtonWidth" :auto-prompt="googleAutoPrompt" class="mt-2" v-show="showButtonGoogle"></button-google-login>
								<button-contentbase-login :width="loginButtonWidth" class="mt-2"></button-contentbase-login>
							</div>
						</div>
						<div class="mt-3" v-if="showMessageBundlePurchasedOrOwned">
							<div class="text-center">
								<img src="/img/packages/confetti-animated-64.gif" ref="refImgBundlePurchased" />
								<p class="fw-bold" v-if="showMessageBundlePurchased">Bundle Purchased!</p>
								<p class="fw-bold" v-if="showMessageBundleOwned">You Own This Bundle!</p>
								<p class="mb-0"><a :href="getBundleUrl" rel="nofollow"><span class="fat-link">View your bundle.</span></a></p>
							</div>
						</div>
						<div :title="getTitleNrCredits" class="cta-stat clearfix" v-show="showNrCredits">
							<div class="cta-icon-container text-center float-start"><img src="/img/packages/contentbase-credit-dollar.png?v=20230303" alt="Price" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span :class="{'strike-through' : isDiscounted, 'bold' : !isDiscounted}">{{getNrCreditsRegular()}}</span></div>
							<div class="cta-text-container float-start ms-2" :class="{'bold' : isDiscounted}" v-show="isDiscounted"><span>{{getNrCreditsDiscount()}}</span></div>
						</div>
						<div title="Discount ends when timer runs out!" class="cta-stat clearfix" v-show="showTimer">
							<div class="cta-icon-container text-center float-start"><img src="/img/packages/clock-green-24.gif?v=20230303" alt="Discount Timer" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3 timer-discount-container"><timer :seconds="timerNrSeconds" @ended="timerEnded()"></timer> - <span>{{discountPercentage}} OFF!</span></div>
						</div>
						<div :title="getSocialMediaIconTitle()" class="cta-stat clearfix" v-if="false"> <!-- disabled for trademark reasons -->
							<div class="cta-icon-container text-center float-start"><img :src="getSocialMediaIconUrl()" alt="Social Media Type" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span>{{getBundleSocialMediaName()}}</span></div>
						</div>
						<div :title="getContentTypeIconTitle()" class="cta-stat clearfix" v-if="false"> <!-- disabled for trademark reasons -->
							<div class="cta-icon-container text-center float-start"><img :src="getContentTypeIconUrl()" alt="Content Type" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span>{{getBundleContentTypeName()}}</span></div>
						</div>
						<div :title="getTitleNrTemplates" class="cta-stat clearfix">
							<div class="cta-icon-container text-center float-start"><img src="/img/packages/templates.svg?v=20230303" alt="Nr. Templates" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span>{{getNrTemplates()}}</span></div>
						</div>
						<div :title="getTitleDimensions" class="cta-stat clearfix">
							<div class="cta-icon-container text-center float-start"><img src="/img/packages/size-icon.svg?v=20230303" alt="Template Dimensions" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span>{{getDimensions()}}</span></div>
						</div>
						<div :title="getTitleFileSize" class="cta-stat clearfix">
							<div class="cta-icon-container text-center float-start"><img src="/img/packages/weight-icon.svg?v=20230303" alt="Bundle Size" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span>{{getFileSize()}}</span></div>
						</div>
						<div :title="getTitleNrViews" class="cta-stat clearfix">
							<div class="cta-icon-container text-center float-start"><img src="/img/packages/view-icon.svg?v=20230303" alt="Nr. Bundle Views" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span>{{getNrViews()}}</span></div>
						</div>
					</div>
					<div class="cta-box cta-box-super-bundle no-select" v-show="showSuperBundleCta">
						<p class="super-bundle-eyebrow">SUPER BUNDLE</p>
						<p class="super-bundle-title">{{superBundleCtaTitle}}</p>
						<p class="super-bundle-copy">{{superBundleCtaCopy}}</p>
						<div class="super-bundle-value-lines">
							<p>{{superBundleCtaBundleTemplateLine}}</p>
							<p>{{superBundleCtaSavingsText}}</p>
						</div>
						<a class="btn super-bundle-button" :href="superBundleCtaUrl">{{superBundleCtaButtonText}}</a>
					</div>
					<div class="cta-box cta-box-wishlist">
						<heart :checked="heartInitValue"
								:guest="isNotLoggedIn"
								guest-checked-text="Sign in to Wishlist!"
								guest-unchecked-text="Add to Wishlist!"
								checked-text="Wishlisted!"
								unchecked-text="Add to Wishlist!"
								@guest-like="guestLike($event)"
								@guest-unlike="guestUnlike($event)"
								@like="like($event)"
								@unlike="unlike($event)"
								@disabled="heartDisabled()"
								@enabled="heartEnabled()">
						</heart>
					</div>
					<!--
					<div class="cta-box cta-box-contents">
						<p class="fw-bold text-center m-0 p-1 no-select">Bundle Contents</p>
						<div class="zip-file-contents ps-2 pe-2 no-select" v-html="oBundle.zipFileDescriptionHtml"></div>
					</div>
					-->
					<div class="cta-box cta-box-specs-2 no-select" v-show="false">
						<div :title="getTitleNrViews" class="cta-stat clearfix">
							<div class="cta-icon-container text-center float-start"><img src="/img/packages/view-icon.svg?v=20230303" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span>{{getNrViews()}}</span></div>
						</div>
						<div :title="getTitlePublishedOn" class="cta-stat clearfix">
							<div class="cta-icon-container text-center float-start"><img src="/img/packages/date-icon.svg?v=20230303" width="24" height="24" /></div>
							<div class="cta-text-container float-start ms-3"><span>{{getPublishedOn()}}</span></div>
						</div>
					</div>
					<div class="cta-box cta-box-faq no-select">
						<p class="m-0"><span class="fat-link" data-bs-toggle="modal" data-bs-target="#modal-container-faq" @click="prepareFaq">FAQ</span></p>
					</div>
				</div>
			</div>

			<div class="row no-select mt-5" v-show="showPopularRelatedBundles">
				<div class="clm col-auto"><img src="/img/packages/trend-icon.svg?v=20230303" alt="Flame" width="25" height="31" /></div>
				<div class="clm col-auto ps-0"><h2 class="mb-0">Popular Bundles</h2></div>
				<div class="clm col w-100 ps-0 pe-3"><hr class="black-divider"/></div>
			</div>

			<div class="row no-select" v-show="showPopularRelatedBundles">
				<div v-for="(oRelatedBundle, j) in oRelatedBundles" :key="oRelatedBundle?.id" class="col-sm-6 col-md-3">
					<div class="related-bundle-background grow shadowbase">
						<div class="related-bundle-container">
							<a :href="oRelatedBundle?.url" class="link-styling">
								<div class="pav_PreviewImageAndName">
									<img class="related-bundle-image" :src="oRelatedBundle?.simpleImage?.url" :alt="oRelatedBundle?.simpleImage?.alt" :width="oRelatedBundle?.simpleImage?.width" :height="oRelatedBundle.simpleImage?.height" @load="onImageLoaded" loading="lazy" decoding="async" fetchpriority="low" />
									<p class="related-bundle-name text-center">{{getRelatedBundleName(oRelatedBundle)}}</p>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="row no-select mt-5" v-show="showReviewSection" ref="reviewSection">
				<div class="clm col-auto"><img src="/img/packages/trend-icon.svg?v=20230303" width="25" height="31" /></div>
				<div class="clm col-auto ps-0"><h2 class="mb-0">Reviews</h2></div>
				<div class="clm col w-100 ps-0 pe-0"><hr class="black-divider"/></div>
			</div>

			<div class="row mt-3" v-show="showAggregateRating">
				<div class="col-md-8">
					<aggregate-rating
						:rating-count1="oBundle.ratingCount1"
						:rating-count2="oBundle.ratingCount2"
						:rating-count3="oBundle.ratingCount3"
						:rating-count4="oBundle.ratingCount4"
						:rating-count5="oBundle.ratingCount5">
					</aggregate-rating>
				</div>
				<div class="col-md-4">
				</div>
			</div>

			<div class="row row-user-review mt-4" v-show="showUserReview">
				<div class="col-md-8">
					<comment-container
						v-if="commentsRequested"
						:enum-comment-types="enumCommentTypes"
						:comments="[userReview]"
						:id-account="oVisitorStatus.accountID"
						:max-chars-title="cfgComment.maxTitleLength"
						:max-chars-body="cfgComment.maxBodyLength"
						:nr-credits-reward="cfgComment.nrCreditsReward"
						@editor-cancelled="editorCancelled($event)"
						@comment-added="reviewCommentAdded($event, true)"
						@comment-edited="reviewCommentEdited($event, true)">
					</comment-container>
				</div>
				<div class="col-md-4">
				</div>
			</div>

			<div class="row row-non-user-reviews mt-4" v-show="showNonUserReviews">
				<div class="col-md-8">
					<comment-container
						v-if="commentsRequested"
						:enum-comment-types="enumCommentTypes"
						:comments="nonUserReviews"
						:id-account="oVisitorStatus.accountID"
						:max-chars-title="cfgComment.maxTitleLength"
						:max-chars-body="cfgComment.maxBodyLength"
						:nr-credits-reward="cfgComment.nrCreditsReward"
						@editor-cancelled="editorCancelled($event)"
						@comment-added="reviewCommentAdded($event, false)"
						@comment-edited="reviewCommentEdited($event, false)">
					</comment-container>
					<button type="button" class="btn btn-primary btn-load-more mt-4" v-show="showLoadMoreNonUserReviews" @click="loadNonUserReviewsNextPage" :disabled="disableLoadMore">
						<span v-if="!disableLoadMore">Load More</span>
						<img v-else src="/img/loaders/spinner-1s-200px-white.svg" />
					</button>
				</div>
				<div class="col-md-4">
				</div>
			</div>

		</div>
	</div>

	<div id="modal-container-sign-in-form" class="modal fade" tabindex="-1" role="dialog">
		<div class="modal-dialog modal-sm modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<!-- only render if not logged in; this prevents pw manager popups -->
					<form-sign-in show-login="false" :width="signInFormWidth" v-if="isNotLoggedIn"></form-sign-in>
					<p v-else>Sign in form unavailable. Please contact support.</p>
				</div>
			</div>
		</div>
	</div>

	<div id="modal-container-payment-form" class="modal fade" tabindex="-1" role="dialog">
		<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<payment-form
						max-width="800"
						v-on:payment-started="paymentStarted($event)"
						v-on:payment-stopped="paymentStopped($event)"
						v-on:payment-completed="paymentCompleted($event)"
						mode="bundle"
						:bundle-id="oBundle.id"
						:bundle-name="oBundle.name"
						:bundle-nr-credits="oBundle.nrCredits"
						:bundle-disc-per-id="oDiscountPeriod?.id"
						:bundle-disc-per-nr-credits="oDiscountPeriod?.nrCredits"
						:usr-nr-credits="userNrCredits"
						v-if="showPaymentForm"
					/>
				</div>
			</div>
		</div>
	</div>

	<div id="modal-container-faq" class="modal fade" tabindex="-1" role="dialog">
		<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
			<div class="modal-content background-gray">
				<div class="modal-body">
					<faq :popup-mode="true" v-if="faqRequested"/>
				</div>
				<div class="modal-footer">
					<input type="button" value="Close" class="btn btn-primary" data-bs-dismiss="modal">
				</div>
			</div>
		</div>
	</div>

	<component :is="'script'" type="application/ld+json" v-html="jsonLD"></component>

	<!--<sale-popper></sale-popper>-->

</template>




<script>
	import { defineAsyncComponent, h } from 'vue';
	import Modal from 'bootstrap/js/dist/modal';
	import { mixinAxios } from '@/js/shared/VueMixins.js';
	const commentsLoader = {
		render() {
			return h('div', { class: 'text-center py-4' }, [
				h('img', {
					src: '/img/loaders/Pulse-1s-200px.png',
					alt: 'Loading reviews',
					class: 'img-payment-form-loader'
				})
			]);
		}
	};

	const commentContainer = defineAsyncComponent({
		loader: () => import('./common/Comments.vue'),
		loadingComponent: commentsLoader,
		delay: 0
	});
	import aggregateRating from './common/AggregateRating.vue';
	import heart from './common/Heart.vue';
	import buttonFacebookLogin from './common/FacebookLoginButton.vue';
	import buttonGoogleLogin from './common/GoogleLoginButton.vue';
	import buttonContentbaseLogin from './common/ContentBaseLoginButton.vue';
	import formSignIn from './common/SignInForm.vue';
	import timer from './common/Timer.vue';
	import { getNrSecsUntilSerializedUtcEnd, versionedImageUrl } from '@/js/shared/utils/common';
	import { addDays, addMonths, countDecimals, isNotNullOrWhiteSpace, pushArray, rangeCap, toFixedNumber, toNrDecimals, toUTC, toYMDHMS } from '@/js/shared/utils';

	const paymentFormLoader = {
		render() {
			return h('div', { class: 'text-center py-4' }, [
				h('img', {
					src: '/img/loaders/Pulse-1s-200px.png',
					alt: 'Loading payment options',
					class: 'img-payment-form-loader'
				})
			]);
		}
	};

	const paymentForm = defineAsyncComponent({
		loader: () => import('./common/PaymentForm.vue'),
		loadingComponent: paymentFormLoader,
		delay: 0
	});

	const faqLoader = {
		render() {
			return h('div', { class: 'text-center py-4' }, [
				h('img', {
					src: '/img/loaders/Pulse-1s-200px.png',
					alt: 'Loading FAQ',
					class: 'img-payment-form-loader'
				})
			]);
		}
	};

	const faq = defineAsyncComponent({
		loader: () => import('./common/Faq.vue'),
		loadingComponent: faqLoader,
		delay: 0
	});

	export default {
		mixins: [mixinAxios],
		components: {
			commentContainer,
			aggregateRating,
			heart,
			buttonFacebookLogin,
			buttonGoogleLogin,
			buttonContentbaseLogin,
			formSignIn,
			paymentForm,
			timer,
			faq
		},
		data: () => ({
			oBundle : {},
			oUserReview : {},
			oNonUserReviews : {},
			nonUserReviewPageIndex: 1,
			oDiscountPeriod : {},
			oRelAccountWLBundle : {},
			oVisitorStatus : {},
			oBundlePayment : {},
			oCreditSpend : {},
			oRelatedBundles : [],
			oSuperBundleCta : null,
			enumSocialMediaTypes : {},
			enumBundleTypes : {},
			enumCommentTypes : {},
			enumBundleCategories : {},
			showButtonFacebook : false,
			showButtonGoogle : false,
			fbAppId : '',
			fbVersion : '',
			gClientId : '',
			cfgComment : {},
			disableLoadMore : false,
			indexSelectedImage : 0,
			anchorSocialMediaType : '',
			anchorBundleType : '',
			anchorCategory : '',
			urlSocialMediaType : '',
			urlBundleType : '',
			urlCategory : '',
			guestClickedDownload : false,
			loginButtonWidth : 230,
			signInFormWidth : 250,
			imageLoading : false,
			mouseHovering : false,
			paymentFormRequested : false,
			faqRequested : false,
			commentsRequested : false,
			reviewSectionObserver : null,
		}),
		props: {
			bundleInfo : { type: Object, required: true, default: () => ({}) }
		},
		beforeCreate() {
		},
		created() {
			this.initData();
		},
		mounted() {
			this.initWLHeart();
			this.setupReviewSectionObserver();
		},
		beforeUnmount() {
			this.destroyReviewSectionObserver();
		},
		methods: {
			initData() {
				var bundleInfo = this.bundleInfo;

				this.oBundle             = bundleInfo.bundle;
				this.oUserReview          = bundleInfo.userReview;
				this.oNonUserReviews      = bundleInfo.nonUserReviews;
				this.oRelatedBundles     = bundleInfo.relatedBundles;
				this.oSuperBundleCta     = bundleInfo.superBundleCta;
				this.oDiscountPeriod      = bundleInfo.discountPeriod;
				this.oVisitorStatus       = bundleInfo.visitorStatus;
				this.enumSocialMediaTypes = bundleInfo.socialMediaTypes;
				this.enumBundleTypes      = bundleInfo.bundleTypes ?? {};
				this.enumCommentTypes     = bundleInfo.commentTypes;
				this.enumBundleCategories = bundleInfo.bundleCategories;
				this.showButtonFacebook   = bundleInfo.showButtonFacebook;
				this.showButtonGoogle     = bundleInfo.showButtonGoogle;
				this.fbAppId              = bundleInfo.fbAppId;
				this.fbVersion            = bundleInfo.fbVersion;
				this.gClientId            = bundleInfo.gClientId;
				this.cfgComment           = bundleInfo.configComment;

				this.setBreadcrumbs();
				this.selectImage(0);
			},
			initWLHeart() {
				this.oRelAccountWLBundle = this.bundleInfo.relAccountWLBundle;
			},
			loadNonUserReviewsNextPage() {
				var idBundle = this.oBundle?.id ?? 0;

				var params = { params : {
					idBundle : idBundle,
					pageIndex : this.nonUserReviewPageIndex
				}};

				var funcPre = () => { this.disableLoadMore = true; };
				var funcPost = () => { this.disableLoadMore = false; };

				var reqGetNonUserReviews = this.mixinAxios(funcPre, funcPost).get('/api/guest/GetNonUserBundleReviewsPaginated/', params)
					.then((resGetNonUserReviews) => {
						var data = resGetNonUserReviews.data;
						pushArray(this.oNonUserReviews.entities, data.entities);
						this.oNonUserReviews.nrPages = data.nrPages;
						this.oNonUserReviews.nrRecords = data.nrRecords;
						this.nonUserReviewPageIndex++;
					});
			},
			getBundle() {
				var idBundle = this.oBundle?.id;

				return this.mixinAxios().get('/api/guest/GetBundle/', { params: { idBundle : idBundle } })
					.then((resGetBundle) => {
						this.oBundle        = resGetBundle.data.bundle;
						this.oDiscountPeriod = resGetBundle.data.discountPeriod;
						this.oVisitorStatus  = resGetBundle.data.visitorStatus;
					});
			},
			getVisitorStatus() {
				var idBundle = this.oBundle.id;

				return this.mixinAxios().post('/api/user/GetVisitorStatus', idBundle, { headers: { 'Content-Type': 'application/json' } })
					.then((visitorStatus) => {
						debugger;
						this.oVisitorStatus = visitorStatus.data;
					});
			},
			getRelatedBundleName(oRelatedBundle) {
				var name        = oRelatedBundle?.name ?? '';
				var nrTemplates = oRelatedBundle?.nrTemplates ?? 0;
				return `${name} - ${nrTemplates} Templates`;
			},
			getImagePreviewUrl(image) {
				return versionedImageUrl(image?.img150Url, image.imgOriSha1);
			},
			getImagePreviewAlt(i) {
				var bundleName = this.oBundle?.name;
				return `${bundleName} ${i}`;
			},
			getImagePreviewWidth(image) {
				return image.img150Width;
			},
			getImagePreviewHeight(image) {
				return image.img150Height;
			},
			selectPrevImage() {
				var cycle = (this.indexSelectedImage == 0);

				var newIndex = (cycle)
					? this.nrImages - 1
					: this.indexSelectedImage - 1;

				this.selectImage(newIndex);
			},
			selectNextImage() {
				var cycle = (this.indexSelectedImage == this.nrImages - 1);

				var newIndex = (cycle)
					? 0
					: this.indexSelectedImage + 1;

				this.selectImage(newIndex);
			},
			selectImage(index) {
				this.imageLoading = (this.indexSelectedImage != index);
				this.indexSelectedImage = index;
			},
			thumbnailClass(index) {
				return {
					'border-selected': index == this.indexSelectedImage,
					'border-unselected': index != this.indexSelectedImage
				}
			},
			getNrViews() {
				var nrViews = this.oBundle?.nrViews ?? 0;
				return `${nrViews} Views`;
			},
			getNrTemplates() {
				var nrTemplates = this.oBundle?.nrTemplates ?? 0;
				var plural = (nrTemplates != 1) ? 's' : '';
				return `${nrTemplates} Template${plural}`;
			},
			getNrCreditsRegular() {
				var nrCreditsRegular = this.oBundle?.nrCredits ?? 0;
				return `$${toNrDecimals(nrCreditsRegular, 2, 2)}`;
			},
			getNrCreditsDiscount() {
				var nrCreditsDiscount = this.oDiscountPeriod?.nrCredits ?? 0;
				return `$${toNrDecimals(nrCreditsDiscount, 2, 2)}`;
			},
			getPublishedOn(){
				var publishedOn = this.oBundle?.publishedOn ?? 0;
				var date = new Date(publishedOn);

				var monthNames = [
					"January", "February", "March",
					"April", "May", "June", "July",
					"August", "September", "October",
					"November", "December"
				];

				var day        = date.getDate();
				var monthIndex = date.getMonth();
				var year       = date.getFullYear();

				return `${day} ${monthNames[monthIndex]} ${year}`;
			},
			getFileSize(){
				var mb = (this.oBundle?.nrBytes ?? 0) / 1024 / 1024;
				var strMb = toFixedNumber(mb, 2);
				return `${strMb} MB`;
			},
			getDimensions(){
				return this.oBundle?.dimensionDescription;
			},
			setBreadcrumbs(){
				var idSocialMediaType = this.oBundle.socialMediaType;
				var idBundleType      = this.oBundle.bundleType;
				var bundleCategory = this.oBundle.bundleCategory ?? {};
				var idBundleCategory = bundleCategory.id;

				this.anchorSocialMediaType = this.enumSocialMediaTypes?.byValue?.[idSocialMediaType]?.description ?? "";
				this.anchorBundleType      = this.enumBundleTypes?.byValue?.[idBundleType]?.name ?? "";
				this.anchorCategory        = this.enumBundleCategories?.byValue?.[idBundleCategory]?.name ?? bundleCategory.name ?? "";

				this.urlSocialMediaType    = `${location.origin}/bundles/soc/${idSocialMediaType}/`;
				this.urlBundleType        = `${location.origin}/bundles/type/${idBundleType}/`;
				this.urlCategory           = `${location.origin}/bundles/cat/${idBundleCategory}/`;
			},
			guestClicksDownload() {
				this.guestClickedDownload = true;
			},
			broadcast(nrCredits) {
				Broadcaster.TransmitCreditsRefresh(nrCredits).then(() => {
				});
			},
			spendAccountCreditOnBundle() { // called when claiming free bundles
				var bundleIDAndVoucherID = {
					bundleID : this.oBundle.id,
					voucherID : 0,
					voucherCode : null
				};

				return this.mixinAxios().post('/api/user/SpendAccountCreditOnBundle', bundleIDAndVoucherID)
					.then((result) => {
						var vals = result.data.vals;
						var data = result.data;

						this.oCreditSpend = data.data;
						this.userNrCredits = vals.nrCredits;
						var paymentCompleted = this.oCreditSpend?.success ?? false;

						// payment completed, so handle it
						if (data.success && paymentCompleted) {
							this.setBundlePaymentManually();
							this.broadcast(vals.nrCredits);
							this.getBundle().then(this.handlePaymentResult);
						} else {
							// something
						}
					})
					.catch(() => {
						//console.log('spendAccountCreditOnBundle() - Fail()');
					});
			},
			onImageLoaded() {
				setTimeout(()=>{
					this.imageLoading = false;
				}, 0); // set higher for testing purposes
			},
			timerEnded() {
				// wait for a second to ensure non-retrieval of discount period that just ended
				setTimeout(() => {
					this.getBundle();
				}, 1000);
			},
			preparePaymentForm() {
				this.paymentFormRequested = true;
			},
			prepareFaq() {
				this.faqRequested = true;
			},
			prepareComments() {
				this.commentsRequested = true;
				this.destroyReviewSectionObserver();
			},
			setupReviewSectionObserver() {
				if (this.commentsRequested || !this.showReviewSection) {
					return;
				}

				this.$nextTick(() => {
					if (this.commentsRequested || !this.showReviewSection) {
						return;
					}

					var reviewSection = this.$refs.reviewSection;
					if (!reviewSection) {
						return;
					}

					if (!('IntersectionObserver' in window)) {
						this.prepareComments();
						return;
					}

					if (this.reviewSectionObserver) {
						return;
					}

					this.reviewSectionObserver = new IntersectionObserver((entries) => {
						var isIntersecting = entries.some(x => x.isIntersecting);
						if (isIntersecting) {
							this.prepareComments();
						}
					}, {
						rootMargin: '400px 0px'
					});

					this.reviewSectionObserver.observe(reviewSection);
				});
			},
			destroyReviewSectionObserver() {
				if (this.reviewSectionObserver) {
					this.reviewSectionObserver.disconnect();
					this.reviewSectionObserver = null;
				}
			},
			paymentStarted(e) {
			},
			paymentStopped(e) {
			},
			paymentCompleted(e) {
				this.setBundlePaymentManually();
				this.hidePaymentOptionsModal();
			},
			setBundlePaymentManually() {
				// todo: dirty hack; this used to come from the server, back in the credits days
				this.oBundlePayment = {};
				this.oBundlePayment.data = this.oBundle;
				this.oBundlePayment.logs = {};
				this.oBundlePayment.logs.bundlePurchased = true;
				this.oBundlePayment.logs.enoughCredits = true;
			},
			hidePaymentOptionsModal() {
				var popup = document.querySelector('#modal-container-payment-form');
				const existingModalInstance = Modal.getInstance(popup);
				existingModalInstance.hide();
			},
			likeOrUnlike(like) {
				var params = {
					params: {
						idBundle: this.oBundle?.id ?? 0,
						wishListed: like
					}
				};

				var funcDummy = () => {};

				this.mixinAxios(funcDummy, funcDummy).get('/api/user/SetWishListBundleStatus/', params)
					.then((resWishListStatus) => {
						this.oRelAccountWLBundle = resWishListStatus.data;
					});
			},
			guestLike(e) {
			},
			guestUnlike(e) {
			},
			like(e) {
				this.likeOrUnlike(true);
			},
			unlike(e) {
				this.likeOrUnlike(false);
			},
			heartDisabled() {
			},
			heartEnabled() {
			},
			getBundleSocialMediaName() {
				return this.enumSocialMediaTypes?.byValue?.[this.oBundle?.socialMediaType]?.description ?? null;
			},
			getBundleContentTypeName() {
				return this.enumBundleTypes?.byValue?.[this.oBundle?.bundleType].name ?? null;
			},
			getSocialMediaIconUrl() {
				var name = this.getBundleSocialMediaName();

				switch (name) {
					case 'Instagram' : return '/img/icons/large/instagram.png';
					case 'Facebook'  : return '/img/icons/large/facebook.png';
					default          : return null;
				}
			},
			getContentTypeIconUrl() {
				var name = this.getBundleContentTypeName();

				switch (name) {
					case 'Canva'     : return '/img/icons/large/canva.png';
					case 'Photoshop' : return '/img/icons/large/photoshop.png';
					default          : return null;
				}
			},
			getSocialMediaIconTitle() {
				var name = this.getBundleSocialMediaName();

				switch (name) {
					case 'Instagram' : return 'This bundle is designed for Instagram.';
					case 'Facebook'  : return 'This bundle is designed for Facebook.';
					default          : return null;
				}
			},
			getContentTypeIconTitle() {
				var name = this.getBundleContentTypeName();

				switch (name) {
					case 'Canva'     : return 'This bundle can be edited on Canva.';
					case 'Photoshop' : return 'This bundle can be edited in Photoshop.';
					default          : return null;
				}
			},
			editorCancelled(idComment) {
			},
			reviewCommentAdded(commentData) {
				this.oUserReview = commentData.comment;
				this.getBundle();
			},
			reviewCommentEdited(commentData, userReview) {
				this.oUserReview = commentData.comment;
				this.getBundle();
			},
			regularCommentAdded(commentData) {
				this.getBundle();
			},
			regularCommentEdited(commentData, userReview) {
				this.getBundle();
			},
			setMouseHover(bool) {
				this.mouseHovering = bool;
			},
			clsImageIndicator(index) {
				return {
					'img-indicator-selected' : (index == this.indexSelectedImage)
				}
			}
		},
		computed: {
			urlEdit() {
				return `/admin/bundle/${this.oBundle.id}/`;
			},
			userNrCredits() {
				return (this.oVisitorStatus?.nrCredits ?? 0);
			},
			isAdmin() {
				return (this.oVisitorStatus?.isAdmin ?? false);
			},
			isLoggedIn() {
				return (this.oVisitorStatus?.isLoggedIn ?? false);
			},
			isNotLoggedIn() {
				return !this.isLoggedIn;
			},
			googleAutoPrompt() {
				return this.isNotLoggedIn;
			},
			isDiscounted() {
				return (this.oDiscountPeriod?.id != null);
			},
			discountPercentage() {
				var percentage = (this.isDiscounted)
					? 100 - ((this.oDiscountPeriod.nrCredits / this.oBundle.nrCredits) * 100)
					: 0;
				var nrDecs = rangeCap(countDecimals(percentage), 0, 0) ?? 0;
				return (percentage != null) ? `${toFixedNumber(percentage, nrDecs)}%` : '';
			},
			isFree() {
				return (this.actualNrCredits == 0);
			},
			isPaid() {
				return (this.actualNrCredits > 0);
			},
			actualNrCredits() {
				// todo: replace calls to this by this.oBundle.nrActualCredits
				return (this.isDiscounted)
					? this.oDiscountPeriod.nrCredits
					: this.oBundle.nrCredits;
			},
			getTitleNrViews() {
				var nrViews = this.oBundle?.nrViews ?? 0;
				return `This bundle has been viewed ${nrViews} times.`;
			},
			getTitleNrTemplates() {
				var nrTemplates = this.getNrTemplates();
				var plural = (nrTemplates != 1) ? 's' : '';
				return `This bundle contains ${nrTemplates} template${plural}.`;
			},
			getTitlePublishedOn() {
				var publishedOn = this.getPublishedOn();
				return `This bundle was published on ${publishedOn}.`;
			},
			getTitleFileSize() {
				var mb = this.getFileSize();
				return `This bundle's file size is ~${mb}.`;
			},
			getTitleDimensions() {
				var dimensions = this.getDimensions();
				return `This bundle's images are of the dimensions ${dimensions}.`;
			},
			getTitleNrCreditsRegular() {
				var nrCredits = this.oBundle?.nrCredits ?? 0;
				return (this.isDiscounted)
					? `This bundle's price was ${nrCredits} credits.`
					: `This bundle costs ${nrCredits} credits.`;
			},
			getTitleNrCreditsDiscount() {
				var nrCreditsDiscount = this.oDiscountPeriod?.nrCredits ?? 0;
				return `This discounted bundle costs ${nrCreditsDiscount} credits.`;
			},
			getTitleNrCredits() {
				return (this.isDiscounted)
					? `This discounted bundle costs ${this.nrCreditsDiscount} credits.`
					: `This bundle costs ${this.nrCreditsRegular} credits.`;
			},
			getTextClaimButton() {
				return 'CLAIM FREE BUNDLE';
			},
			getTextClaimOrBuyButton() {
				return (this.isFree)
					? this.getTextClaimButton
					: this.getTextBuyButton;
			},
			getTextBuyButton() {
				var nrCredits = toNrDecimals(this.actualNrCredits, 2, 2);
				return `BUY FOR $${nrCredits}`;
			},
			showPaymentForm() {
				return (this.isLoggedIn && this.paymentFormRequested);
			},
			showButtonDownload(){
				return (
					!this.oVisitorStatus.isLoggedIn &&
					!this.guestClickedDownload &&
					!this.requestActive
				);
			},
			showButtonClaimOrBuy() {
				return (
					this.oVisitorStatus.isLoggedIn &&
					!this.oVisitorStatus.ownsBundle &&
					!this.oBundlePayment?.logs?.bundlePurchased &&
					!this.requestActive
				);
			},
			showButtonClaim() {
				return (this.isFree && this.showButtonClaimOrBuy);
			},
			showButtonBuy() {
				return (this.isPaid && this.showButtonClaimOrBuy);
			},
			showButtonProcessing() {
				return (
					this.oVisitorStatus.isLoggedIn &&
					!this.oVisitorStatus.ownsBundle &&
					!this.oBundlePayment?.logs?.bundlePurchased &&
					this.requestActive
				);
			},
			showMessageLoginRegister() {
				return this.guestClickedDownload;
			},
			showMessageBuyCredits() {
				return (
					this.oBundlePayment?.data?.id &&
					!this.oBundlePayment?.logs?.enoughCredits
				);
			},
			showMessageBundlePurchased() {
				return (
					this.oBundlePayment?.data?.id &&
					this.oBundlePayment?.logs?.bundlePurchased
				);
			},
			showMessageBundleOwned() {
				return (!this.showMessageBundlePurchased) && (this.oVisitorStatus?.ownsBundle ?? false);
			},
			showMessageBundlePurchasedOrOwned() {
				return (this.showMessageBundlePurchased || this.showMessageBundleOwned);
			},
			nrCreditsShort() {
				var nrCreditsShort = this.oBundlePayment?.vals?.nrCreditsShort ?? 0;
				return toNrDecimals(nrCreditsShort, 0, 2);
			},
			popNrCredits() {
				return this.bundleInfo.popularCreditPackage?.nrCredits ?? 'some';
			},
			popUsdPrice() {
				var popCP = this.bundleInfo?.popularCreditPackage;
				var usd = (popCP?.usdCents ?? 0) / 100;
				var notZero = (usd > 0);
				return (notZero)
					? usd.toFixed(2)
					: 'dollars'
			},
			recNrCredits() {
				return this.oBundlePayment?.vals?.['recNrCredits'] ?? 'some';
			},
			recUsdPrice() {
				var cents = this.oBundlePayment?.vals?.['recNrCents'] ?? 0;
				var usd = (cents / 100);
				var notZero = (usd > 0);
				return (notZero)
					? usd.toFixed(2)
					: 'dollars'
			},
			showNrCredits() {
				return (!this.showMessageBundlePurchased && !this.showMessageBundleOwned && this.isDiscounted);
			},
			showNrCreditsDiscounted() {
				return (this.showNrCredits && this.isDiscounted);
			},
			showDescription() {
				return isNotNullOrWhiteSpace(this.oBundle?.descriptionHtml) ?? false;
			},
			showPopularRelatedBundles() {
				return this.oRelatedBundles?.length > 0 ?? false;
			},
			showSuperBundleCta() {
				return (this.oSuperBundleCta?.id ?? 0) > 0;
			},
			isSuperBundleCompletionCta() {
				return this.isLoggedIn && ((this.oSuperBundleCta?.nrOwnedBundles ?? 0) > 0);
			},
			superBundleCtaTitle() {
				return (this.isSuperBundleCompletionCta)
					? 'Complete Your Super Bundle'
					: 'Get the Full Content Kit';
			},
			superBundleCtaCopy() {
				var name = this.oSuperBundleCta?.name ?? 'this super bundle';
				var nrOwnedBundles = this.oSuperBundleCta?.nrOwnedBundles ?? 0;
				var nrBundles = this.oSuperBundleCta?.nrBundles ?? 0;

				return (this.isSuperBundleCompletionCta)
					? `You already own ${nrOwnedBundles} of ${nrBundles} bundles.`
					: `This bundle is included in ${name}.`;
			},
			superBundleCtaBundleTemplateLine() {
				var bullet = String.fromCharCode(8226);
				return `${this.superBundleCtaBundleText} ${bullet} ${this.superBundleCtaTemplateText}`;
			},
			superBundleCtaBundleText() {
				var nrBundles = this.oSuperBundleCta?.nrBundles ?? 0;
				var plural = (nrBundles == 1) ? '' : 's';
				return `${nrBundles.toLocaleString()} bundle${plural}`;
			},
			superBundleCtaTemplateText() {
				var nrTemplates = this.oSuperBundleCta?.nrTemplates ?? 0;
				var plural = (nrTemplates == 1) ? '' : 's';
				return `${nrTemplates.toLocaleString()} template${plural}`;
			},
			superBundleCtaSavingsText() {
				var savings = this.oSuperBundleCta?.savings ?? 0;
				return `Save $${toNrDecimals(savings, 2, 2)}`;
			},
			superBundleCtaButtonText() {
				return (this.isSuperBundleCompletionCta)
					? 'Complete My Bundle'
					: 'View Super Bundle';
			},
			superBundleCtaUrl() {
				return this.oSuperBundleCta?.url ?? '/super-bundles/';
			},
			showTimer() {
				return (this.showNrCreditsDiscounted && this.isDiscounted && this.oDiscountPeriod.showTimer);
			},
			showNavArrows() {
				//return (this.mouseHovering);
				return true;
			},
			timerNrSeconds() {
				return (this.showTimer)
					? getNrSecsUntilSerializedUtcEnd(this.oDiscountPeriod?.end)
					: 0;
			},
			getLoginRedirectUrl() {
				return `${location.origin}/login/?redirect=${location.href}`;
			},
			getRegisterRedirectUrl() {
				return `${location.origin}/register/?redirect=${location.href}`;
			},
			getCreditsRedirectUrl() {
				return `${location.origin}/credits/?redirect=${location.href}`;
			},
			getBundleUrl() {
				var idBundle = this.oBundle?.id ?? 0;
				return `${location.origin}/my-bundles/${idBundle}/`;
			},
			oBundleImages() {
				return this.oBundle?.images ?? [];
			},
			heartInitValue() {
				return this.oRelAccountWLBundle?.wishListed ?? false;
			},
			nrCreditsRegular() {
				return this.oBundle?.nrCredits ?? 0;
			},
			nrCreditsDiscount() {
				return this.oDiscountPeriod?.nrCredits ?? 0;
			},
			nrImages() {
				return this.oBundle?.images?.length ?? 0;
			},
			selectedImage() {
				return this.oBundle?.images?.[this.indexSelectedImage];
			},
			selectedImageUrl() {
				var oImage = this.selectedImage;
				return versionedImageUrl(oImage?.img900Url, oImage?.imgOriSha1);
			},
			selectedImageAlt() {
				return this.oBundle?.name;
			},
			selectedImageSrcSet() {
				const i = this.selectedImage;
				const widths = [350, 400, 450, 500, 600, 700, 800, 900, 1000, 1100, 1200];
				return widths
					.map(w => {
						const url = i[`img${w}Url`] + `?v=${i.imgOriSha1}`;
						return url && url.trim() ? `${url} ${w}w` : null;
					})
					.filter(Boolean)
					.join(', ');
			},
			selectedImageSizes() {
				  return '(min-width: 992px) 900px, 100vw';
			},
			selectedImageWidth() {
				return this.selectedImage?.img900Width ?? 0;
			},
			selectedImageHeight() {
				return this.selectedImage?.img900Height ?? 0;
			},
			schemaPriceValidUntil() {
				var dtUntil = (this.isDiscounted)
					? new Date(this.oDiscountPeriod.end)
					: addDays(toUTC(new Date()), 1);

				return toYMDHMS(dtUntil);
			},
			schemaSomeFutureDate() {
				var dtFuture = addMonths(toUTC(new Date()), 1);
				return toYMDHMS(dtFuture);
			},
			jsonLdReviewComments() {
				return this.nonUserReviews.map(x => ({
					"@type": "Review",
					"datePublished": x.createdOn,
					"reviewBody": x.body,
					"reviewRating": {
						"@type": "Rating",
						"ratingValue": x.rating,
						"bestRating":5,
						"worstRating":1,
					},
					"author": {
						"@type": "Person",
						"name": x.name
					}
				}));
			},
			newUserReview() {
				var type = this.enumCommentTypes.byName['rating'].value;

				return {
					id              : 0,
					type            : type,
					rating          : 0,
					title           : '',
					body            : '',
					editable        : true,
					edited          : false,
					name            : this.oVisitorStatus.firstName,
					avatarUrl       : this.oVisitorStatus.avatarUrl,
					bundleID        : this.oBundle.id,
					accountID       : this.oVisitorStatus.accountID,
					parentCommentID : null,
					topCommentID    : null
				};
			},
			userReview() {
				return (this.oUserReview?.id)
					? this.oUserReview
					: (this.oVisitorStatus.ownsBundle)
					? this.newUserReview
					: {};
			},
			nonUserReviews() {
				return (this.oNonUserReviews?.entities ?? []);
			},
			showAggregateRating() {
				return (this.oBundle.rating != 0);
			},
			showUserReview() {
				return (this.userReview?.id != null);
			},
			showNonUserReviews() {
				return (this.nonUserReviews?.length > 0);
			},
			showReviewSection() {
				return (this.showAggregateRating || this.showUserReview || this.showNonUserReviews);
			},
			showLoadMoreNonUserReviews() {
				var nrPages = this.oNonUserReviews?.nrPages ?? 0;
				return (this.nonUserReviewPageIndex < nrPages);
			},
			jsonLD() {
				var id              = this.oBundle?.id ?? 0;
				var name            = this.oBundle?.name ?? '';
				var images          = this.oBundle?.images.map(x => this.getImagePreviewUrl(x)) ?? [];
				var desc            = this.oBundle?.openGraphImageAlt ?? '';
				var sku             = `cb${id}`;
				var mpn             = `cb${id}`;
				var url             = this.oBundle?.url ?? '';
				var nrCredits       = this.actualNrCredits;
				var priceValidUntil = (this.isDiscounted) ? this.schemaPriceValidUntil : this.schemaSomeFutureDate;
				var ratingValue     = toFixedNumber(this.oBundle?.rating ?? 0, 1);
				var reviewCount     = this.oBundle?.nrRatings ?? 0;

				var jsonLD = {
					"@context":"https://schema.org/",
					"@type":"Product",
					"name":name,
					"image":images,
					"description":desc,
					"sku":sku,
					"mpn":mpn,
					"brand":{
						"@type":"Brand",
						"name":"ContentBASE"
					},
					"offers":{
						"@type":"Offer",
						"url":url,
						"priceCurrency":"USD",
						"price":nrCredits,
						"priceValidUntil":priceValidUntil,
						"itemCondition":"https://schema.org/NewCondition",
						"availability":"https://schema.org/InStock"
					},
				}

				if (this.showAggregateRating) {
					jsonLD.aggregateRating = {
						"@type":"AggregateRating",
						"ratingValue":ratingValue,
						"reviewCount":reviewCount,
						"bestRating":5,
						"worstRating":1
					};
				}

				if (this.showNonUserReviews) {

					jsonLD.review = this.jsonLdReviewComments;
				}

				return JSON.stringify(jsonLD, null, 4);
			}
		},
		watch: {
			showMessageBundlePurchased(newVal, oldVal) {
				if (newVal) {
					// do it on next tick, because this element is within a v-if
					this.$nextTick(() => {
						var element = this.$refs['refImgBundlePurchased'];

						party.confetti(element, {
							count: party.variation.range(100, 100),
						});
					});
				}
			},
			showReviewSection(showReviewSection) {
				if (showReviewSection) {
					this.setupReviewSectionObserver();
				} else {
					this.destroyReviewSectionObserver();
				}
			}
		}
	};
</script>




<style scoped>@import '../scss/vue/ArticleHtml.scss'</style>
<style scoped>
	[v-cloak] {
		display: none;
	}

	.main-content {
		max-width: 900px;
		margin: auto;
		margin-top: -485px;
	}

	.row-image-bundles {
		display: none;
	}

	.bundle-image-container {
		border-radius: 15px;
		margin-top: 16px;
		position: relative;
	}

	.bundle-image-container:first-child {
		margin-top: 0px;
	}

	.bundle-image-container img {
		width: 100%;
		border-radius: 15px;
	}

	img.bundle-image-full {
		height: 100%;
		display: flex;
		z-index: 0;
	}

	.bundle-image-container img.img-overlay {
		width: calc(100% - 24px);
		height: 100%;
		position: absolute;
		top: 0px;
		left: 12px;
	}

	.bundle-image-container button.nav-arrow {
		position: absolute;
		z-index: 1;
		width: 40px;
		height: 40px;
		top: 50%;
		transform: translate(0%, -50%);
		cursor: pointer;
		border: 5px solid black;
		border-radius: 100%;
		background-color: white;
		background-position: center;
		background-repeat: no-repeat;
		opacity: 0.75;
	}

	.bundle-image-container button.nav-arrow:hover {
		background-color: #c8c8c8;
	}

	.bundle-image-container button.arrow-prev {
		left: 24px;
		background-image: url(/img/icons/fat-arrow-left.png);
	}

	.bundle-image-container button.arrow-next {
		right: 24px;
		background-image: url(/img/icons/fat-arrow-right.png);
	}

	.carousel-indicator-container {
		border: 0px solid red;
		position: absolute;
		top: 12px;
		left: 12px;
		width: calc(100% - 24px);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.carousel-indicator {
		border: 0px solid green;
		background: rgba(200, 200, 200, 0.75);
		border-radius: 20px;
		margin: 0px;
		padding: 0px;
		list-style-type: none;
		font-size: 0px; /* remove undesired space */
	}

	.img-indicator {
		display: inline-block;
		width: 8px;
		height: 8px;
		margin: 6px 8px;
		cursor: pointer;
		background-color: transparent;
		border: 2px solid white;
		border-radius: 100%;
	}

	.img-indicator-selected {
		background-color: white;
	}

	.black-bg {
		z-index: 2;
		opacity: 0.25;
	}

	.img-loader {
		z-index: 3;
	}

	img.bundle-image-preview {
		height: 100%;
		cursor: default;
	}

	.border-selected {
		border: 0px solid #0069d9;
	}

	.border-unselected {
		border: 0px solid #FFFFFF;
	}

	.cta-box {
		-webkit-box-shadow: 0px 10px 20px 5px #EEEEEE;
		-moz-box-shadow: 0px 10px 20px 5px #EEEEEE;
		box-shadow: 0px 10px 20px 5px #EEEEEE;
		border-radius: 15px;
		background: white;
		width: 270px;
	}

	.cta-box-specs {
		padding: 16px 0px 24px 0px;
	}

	.cta-box-specs-2 {
		padding: 16px 0px 24px 0px;
		margin-top: 24px;
	}

	.cta-box-wishlist {
		margin-top: 24px;
	}

	.cta-box-super-bundle {
		margin-top: 24px;
		padding: 18px;
		border: 1px solid #b8eedf;
		background: linear-gradient(180deg, #edfff7 0%, #ffffff 100%);
	}

	.cta-box-contents {
		margin-top: 24px;
		padding: 0px 0px 16px 0px;
	}

	.cta-box-faq {
		margin-top: 24px;
		padding: 16px;
	}

	.cta-stat {
		margin: 16px 0 0 16px;
		cursor: help;
	}

	.cta-stat:first-child {
		margin-top: 0px;
	}

	.cta-icon-container {
		width: 24px;
	}

	.cta-icon-container img {
		width: 24px;
		height: 24px;
	}

	.cta-text-container {
		margin-top: 2px;
	}

	div.cta-button-container {
		text-align: center;
	}

	input.cta-button-styling {
		width: 90%;
		height: 48px;
		font-size: 120%;
	}

	input.cta-button-styling-smaller {
		border: 0px solid black;
		background: #ff7ff4;
		color: white;
		border-radius: 40px;
		font-weight: bold;
		font-size: 120%;
		padding: 6px 24px;
	}

	.super-bundle-eyebrow {
		margin: 0 0 8px 0;
		color: #00856f;
		font-size: 12px;
		font-weight: 800;
		letter-spacing: 0.16em;
	}

	.super-bundle-title {
		margin: 0 0 8px 0;
		color: #0f1f52;
		font-size: 20px;
		font-weight: 800;
		line-height: 1.15;
	}

	.super-bundle-copy {
		margin: 0 0 10px 0;
		color: #334155;
		font-size: 14px;
		line-height: 1.45;
	}

	.super-bundle-value-lines {
		margin: 0 0 14px 0;
		padding: 10px 12px;
		border: 1px solid #b8eedf;
		border-radius: 16px;
		background: #dffcf0;
		color: #13795b;
		font-size: 14px;
		font-weight: 800;
		line-height: 1.35;
		text-align: center;
	}

	.super-bundle-value-lines p {
		margin: 0;
	}

	a.super-bundle-button {
		width: 100%;
		border: 0;
		border-radius: 999px;
		background: #138a7a;
		color: #ffffff;
		font-weight: 800;
		padding: 12px 16px;
		text-decoration: none;
	}

	a.super-bundle-button:hover,
	a.super-bundle-button:focus,
	a.super-bundle-button:active {
		background: #0f766e;
		color: #ffffff;
	}

	div.cta-login-or-register {
		border: 1px solid lightgray;
		padding: 10px;
		margin: 0px 10px;
		border-radius: 10px;
	}

	div.cta-login-or-register p {
		font-size: 1.0em;
		font-weight: normal;
	}

	div.related-bundle-background {
		background-color: white;
		padding: 10px;
		border-radius: 10px;
		margin-top: 90px;
		cursor: pointer;
		max-width: 300px;
	}

	div.related-bundle-container {
		margin-top: -70px;
		border-radius: 10px;
	}

	img.related-bundle-image {
		width: 100%;
		height: 100%;
		border-radius: 10px;
	}

	p.related-bundle-name {
		margin: 10px 0px 0px 0px;
		color: #000000;
		font-weight: bold;
		text-decoration: none;
	}

	a.link-styling {
		text-decoration-color: black;
	}

	a.link-styling:hover, a.link-styling:focus, a.link-styling:active {
		text-decoration: none;
	}

	div.zip-file-contents {
		max-height: 500px;
		overflow-y: auto;
		padding-bottom: 10px;
	}

	.description-box {
		border-radius: 10px;
		padding: 15px 25px 15px 25px;
		background-color: white;
	}

	h1 {
		font-size: 35px;
		font-weight: normal;
		color: #000000;
	}


	.span-edit {
		/*
		margin-left: 5px;
		font-size: 20px;
		*/
	}

	.span-edit a {
		text-decoration: underline;
	}

	:deep(.description-box h2) {
		font-size: 30px;
		font-weight: bold;
		color: #000000;
	}

	:deep(.description-box h3) {
		font-size: 25px;
		font-weight: bold;
		color: #000000;
	}

	:deep(.description-box h4) {
		font-size: 20px;
		font-weight: bold;
		color: #000000;
	}

	:deep(.description-box p) {
		font-size: 16px;
	}

	:deep(.description-box img) {
		max-width: 100%;
	}

	.grow {
		transition: none;
	}

	.grow:hover {
		transform: none;
	}

	.black-divider {
		border: 1px solid black;
		margin-top: 21px;
		margin-bottom: 11px;
		opacity: 1;
	}

	.background-graphic {
		background-image: url(/img/packages/bg-package-2.svg?v=20230303);
		background-color: #e0e7ff;
		height: 500px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		margin: 0;
	}

	.timer-discount-container {
		font-weight: bold;
		color: #13795b;
	}

	.bold {
		font-weight: bold;
	}

	.strike-through {
		text-decoration: line-through;
		text-decoration-thickness: 2px;
		text-decoration-color: red;
	}

	.background-blue {
		background: #d9efff;
	}

	.background-gray {
		background: #e2e8f0;
	}

	#modal-container-faq .modal-body {
		padding: 0;
	}

	#modal-container-faq .modal-footer {
		border-top: 0;
		padding: 0 1.5rem 1.5rem 0;
	}

	.col-bundle-name {
		display: flex;
		align-items: center;
		justify-content: left;
	}

	.col-bundle-name h1 {
		margin: 0px;
	}

	.col-bundle-tags {
		margin-top: 8px;
		display: flex;
		align-items: center;
		justify-content: left;
		flex-wrap: wrap;
		gap: 12px;
	}

	.bundle-tag {
		border: 1px solid rgb(67,56,202);
		background: white;
		color: rgb(67,56,202);
		font-weight: normal;
		border-radius: 5px;
		padding: 2px 10px;
	}

	.bundle-tag:hover {
		background: #f8f8f8 !important;
	}

	.right-section {
		margin-top: 24px;
	}

	.btn-load-more {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 120px;
	}

	.btn-load-more img {
		height: 24px; /* equal to font */
		width: auto;
	}

	.img-payment-form-loader {
		width: 48px;
		height: 48px;
	}

	.shadowbase {
		-webkit-box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
		-moz-box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
		box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
	}

	.fat-link {
		color: #0066ff;
		font-weight: bold;
		text-decoration: underline;
		cursor: pointer;
	}

	@media all and (min-width: 400px) {
		.bundle-image-container button.nav-arrow {
			width: 45px;
			height: 45px;
		}

		.img-indicator {
			width: 12px;
			height: 12px;
			margin: 6px 8px;
		}
	}

	@media all and (min-width: 992px) {

		.main-content {
			max-width: 1200px;
		}

		.col-bundle-tags {
			margin-top: 0px;
			justify-content: right;
		}

		.right-section {
			margin-top: 0px;
		}

		.row-image-bundles {
			display: flex;
		}

		div.bundle-image-container {
			margin-top: 16px;
		}

		div.bundle-image-container:first-child {
			margin-top: 16px;
		}

		.grow {
			transition: all .3s ease;
		}

		.grow:hover {
			transform: scale(1.08);
		}

		.border-selected {
			border: 3px solid rgba(67,56,202);
			border-radius: 5px;
		}

		.border-unselected {
			border: 3px solid #FFFFFF;
			border-radius: 5px;
		}

		img.bundle-image-preview {
			cursor: pointer;
		}
	}
</style>
